import { Component, OnInit } from '@angular/core';
import { TableColumn } from '../../../dto/util/table-column';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { ActuacionExpedienteIcaFiltroDTO } from '../../../dto/expediente/actuaciones-ica.filtro.dto';
import { ExpedienteIcaDTO } from '../../../dto/expediente/expediente-ica.dto';
import { ActuacionExpedienteIcaDTO } from '../../../dto/expediente/actuaciones-ica.dto';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedienteService } from '../../../services/expediente.service';
import { UtilService } from '../../../services/util.service';
import { ModalService } from '../../../services/util/modal.service';
import { SolicitudDocumentosComponent } from '../solicitud-documentos/solicitud-documentos.component';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { Constants } from '../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import {EntidadApiResponse} from "../../../dto/entidad/entidad-response.dto";
import {EntidadService} from "../../../services/entidad.service";

@Component({
  selector: 'app-detalle-ica',
  templateUrl: './detalle-ica.component.html',
  styleUrl: './detalle-ica.component.scss',
})
export class DetalleIcaComponent implements OnInit {
  expedienteIcaDto?: ExpedienteIcaDTO;
  historialExpediente: ActuacionExpedienteIcaDTO[] = [];
  idExpediente = 0;
  usuarioCreadorId = 0;
  entidadId = 7;
  entidad!: EntidadApiResponse;
  columns: TableColumn[] = [];
  filtros: FiltroDto<ActuacionExpedienteIcaFiltroDTO> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'Usuario',
    filtros: {},
  };
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;
  isCreator = false;
  public role = '';

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  tableText: any = {};

  guiaText: any = {};
  guiaICAText: any = {};
  showGuia:boolean = true;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly expedienteService: ExpedienteService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly modalService: ModalService,
    private readonly translate: TranslateService,
    private entidadService: EntidadService
  ) {
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }
    this.route.params.subscribe(params => {
      this.idExpediente = params['expedienteId'];
      this.usuarioCreadorId = params['usuarioId'];
    });
    // Multilenguaje
    combineLatest({
      tabla: this.translate.stream('detalle-DNDA'),
      guias: this.translate.stream('guias-interactivas'),
      guiaIca: this.translate.stream('guia-ICA'),
    }).subscribe(({ tabla, guias, guiaIca }) => {
      // Asignar traducciones a variables
      this.tableText = tabla;
      this.guiaText = guias;
      this.guiaICAText = guiaIca;
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.initColumns();
    this.cargarEntidad();
    this.filtradoExpediente(this.idExpediente);
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
    // Se toma la información del usuario que inicia sesión
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.isCreator = infoInicioSesion.idUsuario === +this.usuarioCreadorId;
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaText['expediente-titulo'],
      descripcionPantalla: this.guiaICAText['descripcion-pantalla'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaICAText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaICAText['encabezado-titulo'],
            description: this.guiaICAText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaICAText['crear-solicitud-titulo'],
            description: this.guiaICAText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historicoBtn',
          popover: {
            title: this.guiaICAText['historico-titulo'],
            description: this.guiaICAText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#documentos',
          popover: {
            title: this.guiaICAText['documentos-titulo'],
            description: this.guiaICAText['documentos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaICAText['historico-titulo'],
            description: this.guiaICAText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaICAText['filtro-titulo'],
            description: this.guiaICAText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#marca',
          popover: {
            title: this.guiaICAText['marca-titulo'],
            description: this.guiaICAText['marca-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#usuario',
          popover: {
            title: this.guiaICAText['usuario-titulo'],
            description: this.guiaICAText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado',
          popover: {
            title: this.guiaICAText['estado-titulo'],
            description: this.guiaICAText['estado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        }
      ],
    };
    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_DETALLE_ICA) != null ? false : this.showGuia
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (infoInicioSesion.primerInicioSesion && isShowGuia) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
      sessionStorage.setItem(Constants.SHOW_GUIA_DETALLE_ICA, 'false')
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
  }

  filtradoExpediente(idExpediente: number) {
    this.expedienteService
      .getExpedientesIca(idExpediente)
      .subscribe(response => {
        this.expedienteIcaDto = response;
        this.historialExpediente = this.expedienteIcaDto['actuaciones'];
        this.initColumns();
      });
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }

  initColumns() {
    this.columns = [
      {
        id: 'marca',
        field: 'marca_tiempo',
        title: this.tableText['marca'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'marca_tiempo',
        pipe: 'dd/MM/yyyy HH:mm',
      },
      {
        id: 'usuario',
        field: 'usuario',
        title: this.tableText['usuario'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'usuario',
      },
      {
        id: 'estado',
        field: 'estado_proceso',
        title: this.tableText['estado'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'estado_proceso',
      },
    ];
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}/solicitudes`,
    ]);
  }

  openModal(): void {
    const modalData: any = {
      entidadId: this.entidadId,
      expedienteId: this.idExpediente,
      numeroProceso: this.expedienteIcaDto?.numero_proceso,
    };

    this.modalService.openModal(SolicitudDocumentosComponent, modalData);
  }
}
